<script setup lang="ts">
import { computed } from "vue";
import { ProjectListed } from "@/apps/page/project/sidebar/sections/tool/project-listed.interface";
import ProjectCard from "@/apps/page/project/sidebar/sections/ProjectCard.vue";
import ToolProjectSection from "@/views/page/ToolProjectSection.vue";
import { PageSection } from "@/apps/page/page.interfaces";
import { useSections } from "@/apps/page/services/useSections";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";

const props = defineProps<{
    project: ProjectListed;
    fontFamily: string;
    styleValues: PageSection["styleValues"];
    scrollAnimationType?: ScrollAnimationType;
}>();

const { getSectionTypeByTool } = useSections();

const isScriptProject = ["cookie", "coffee", "ticker"].includes(props.project.tool);
const icon = computed(() => getSectionTypeByTool(props.project.tool)?.icon);

const preview = {
    width: isScriptProject ? 660 : 1540,
    height: isScriptProject ? "300px" : "auto",
    zoom: isScriptProject ? 0.41 : 0.175,
};
</script>

<template>
    <div class="mb-3 max-w-[280px]">
        <ProjectCard :name="project.name" :subtitle="'/' + project.uuid" :icon="icon">
            <div
                class="relative overflow-hidden"
                :style="{ zoom: preview.zoom, width: preview.width + 'px', height: preview.height }"
            >
                <ToolProjectSection
                    :type="project.tool"
                    :uuid="project.uuid"
                    :fontFamily="fontFamily"
                    :styleValues="styleValues"
                    :isProjectPublished="project.access === 'published'"
                    isListOfItemsToPick
                    :scrollAnimationType="scrollAnimationType"
                />
            </div>
        </ProjectCard>
    </div>
</template>
